<div class="flex flex-col space-y-4">
  <div class="flex flex-col items-start">
    <h1 class="font-semibold text-2xl">Possible solutions</h1>
    <span class="text-text-secondary/80">{{ selectedPeriodLabel() }}</span>
  </div>

  @switch (dataState().status) {
    @case ('loading') {
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        @for (i of [1, 2, 3]; track i) {
          <app-loading-skeleton variant="card" />
        }
      </div>
    }
    @case ('error') {
      <app-error-state title="Failed to load solutions" [message]="error()!" (retry)="onRetry()" />
    }
    @case ('success') {
      @if (isEmpty()) {
        <app-empty-state message="There are no solutions configured for this project." title="No solutions available" />
      } @else {
        <div animate.enter="content-enter" class="grid grid-cols-1 lg:grid-cols-3 gap-4">
          @for (item of data()!; track item.solution.id) {
            <div class="col-span-1">
              <app-solution-card [products]="item.products" [solution]="item.solution" />
            </div>
          }
        </div>
      }
    }
  }
</div>
